import { useMutation } from "@apollo/client";
import { App } from "antd";
import { useTranslation } from "react-i18next";
import { RolesType } from "../types/user";
import { useAppSelector } from "../store";
import {
  userId,
} from "../store/slices/user";
import useCurrentUser from "./useCurrentUser";
import { ADD_AVAILABILITY, DELETE_AVAILABILITY } from "../components/Availabilities/availabilities.gql";

const useAvailability = () => {
  const { t } = useTranslation();
  const doctorId: string = useAppSelector(userId) as NonNullable<RolesType>;
  const { message } = App.useApp();
  const {
    refetchUser,
    availabilities
  } = useCurrentUser(); // add get availabilities query and use it instead

  const [add, {
    loading
  }] = useMutation(
    ADD_AVAILABILITY,
    {
      fetchPolicy: "no-cache",
      onError({ graphQLErrors }) {
        message.error(graphQLErrors[0].message);
      },
      onCompleted() {
        refetchUser();
        message.success("Orario aggiunto con successo");
      }
    },
  );

  const [remove, {
    loading: deleteLoading
  }] = useMutation(
    DELETE_AVAILABILITY,
    {
      fetchPolicy: "no-cache",
      onError({ graphQLErrors }) {
        message.error(graphQLErrors[0].message);
      },
      onCompleted() {
        refetchUser();
        message.success("Orario eliminato con successo");
      }
    },
  );

  const addAvailability = async (day: string, from: string, to: string) => {
    await add({
      variables: {
        id: Number(doctorId),
        day,
        from,
        to
      }
    });
  };

  const deleteAvailability = async (id: string) => {
    if (availabilities.length === 1) {
      message.error(t("availabilityPage.error.atLeastOneAvailabilityRequired"));
      return;
    }
    await remove({
      variables: {
        id: Number(id)
      }
    });
  };

  return {
    addAvailability,
    deleteAvailability,
    loading,
    deleteLoading
  };
};

export default useAvailability;
